var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links"},_vm._l((_vm.links),function(link,index){return _c('a',{key:index,attrs:{"href":link.url,"target":"_blank","rel":"noopener"}},[_vm._v(" "+_vm._s(link.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }